module.exports = __webpack_public_path__ + "static/media/img_11.ccdf5916.png";